import AlertSepaSetupSuccessContainer from './alert-sepa-setup-success-container';

export default AlertSepaSetupSuccessContainer;
